import { DynamicLoaderRegistry, ColorFrom } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { AngleFrom, NumberInputFrom } from '@tencent/wb-ext-form';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import { ImageTileFlipType } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { EEffectAlgn } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface IFillGradualValues {
    activePointId?: string,
    activeColor?: ITDColor,
    curGradualType?: string,
    curDirect?: IDirection,
    curAngle?: number,
    pointArray?: any,
    presetItem?: any,
}

export interface IDirection {
    title: string;
    id?: string;
    rect?: {
        b: number;
        l: number;
        r: number;
        t: number;
    };
    angle?: number;
    range?: number[];
    tileRect?: {
        b: number;
        l: number;
        r: number;
        t: number;
    };
}

export interface IFillImageValues {
    curImgFillType?: string,
    imgData?: { src: string },
    alpha?: number,
    curMirrorImageType?: ImageTileFlipType,
    curImageAlign?: EEffectAlgn,
}

export interface IFillFeature extends IBaseDrawerFeature {
    fillSolidValues: ITDColor;
    fillGradualValues: IFillGradualValues;
    fillImageValues: IFillImageValues;
    fillPattValues: string;
    initPropsCallback(): void;
    getFillTypes(): { key: string, content: string }[];
    getCheckedFillType(): string;
    handleFillTypeChange(type: string): void;
    handleSolidColorChange(color: ITDColor, from: ColorFrom | number, hasAlpha: boolean): void;
    handleSolidOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void;
    handleGradualTypeChange(type: string): void;
    handleGradualAngleChange(value: number, from?: AngleFrom, dragEnd?: boolean): void;
    handleGradualDirectionChange(value: IDirection): void;
    handleGradualOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void;
    renderGradualFill(): ReactElement;
    handleImageBgFromFile(): void;
    handleImageBgFromClipBoard(): void;
    renderImgFill(): ReactElement;
    handleImageOpacityChange(value: number, from?: NumberInputFrom, dragEnd?: boolean): void;
    getColorOpacity(): number;
    getFillDirectionOptions();
    shouldAngleDisabled(): boolean;
    getColorSelectButton(): JSX.Element;
    renderFillContent(): ReactElement | null;
    renderGradualDirection(): ReactElement | null;
}

export const IFillFeature = Symbol.for('feature:drawer-font-fill');

DynamicLoaderRegistry.merge(IFillFeature, {
    useFactory: async () => {
        const { FillFeature } = await import('./fill-feature');
        return FillFeature;
    },
    on: loadTask,
});
